export default __webpack_public_path__ + "static/media/flag-portugal.b8891b76.svg";